copyToClipboardModalController.$inject = ['$scope', '$translate', '$uibModalInstance', 'AlertingFactory', 'controllerParams'];
export function copyToClipboardModalController($scope, $translate, $uibModalInstance, AlertingFactory, controllerParams) {

  $scope.submit = submit;
  $scope.cancel = cancel;

  init();

  function submit() {
    const messages = {
      success: 'parameters/quick_replies/details/copy_test_link_success',
      error: 'parameters/quick_replies/details/copy_test_link_error'
    };

    navigator.clipboard.writeText($scope.params.input).then(() => {
      AlertingFactory.success(messages.success);
    }, () => {
      AlertingFactory.error(messages.error);
    });

    $uibModalInstance.close($scope.data);
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function init() {
    $scope.params = controllerParams;
  }
}
